import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IOAuthClient } from '../../types/OAuth/IOAuthClient';

export interface IGetOAuthClientsResult extends IGetItemsResult {
  oauthClients: IOAuthClient[];
}

export class GetOAuthClientsRequest extends Request<IGetItemsParams, IGetOAuthClientsResult> {
  constructor(params: IGetItemsParams) {
    super('getOAuthClients', params);
  }
}
